import ACCOUNT_TYPE from '../../User/enums/accountType';
import * as authActions from '../actions/authActions';
import linkStore from '../../Global/store/linkStore';

export class AuthService {

    static PROCESS_REFRESH = false;
    // eslint-disable-next-line no-magic-numbers
    static DEFAULT_MIN_PASSWORD_LENGTH = 8;

    static ALLOWED_ACCOUNT_TYPES_FOR_CHANGE_PASSWORD = [
        ACCOUNT_TYPE.SYSTEM.value,
        ACCOUNT_TYPE.PHONE.value,
        ACCOUNT_TYPE.EMAIL.value,
    ];

    /**
     * Получаем информацию по пользователю
     * @param userProfile
     * @returns {null|any}
     */
    static getUserInfo(userProfile = null) {
        try {
            if (userProfile) {
                userProfile.personality = userProfile.personality && (userProfile.personality.lastName || userProfile.personality.firstName) ? userProfile.personality : {
                    lastName: userProfile.personality && userProfile.personality.lastName ? userProfile.personality.lastName : 'Анонимный',
                    firstName: userProfile.personality && userProfile.personality.firstName ? userProfile.personality.firstName : 'Пользователь',
                };
                userProfile.personality.name = userProfile.personality.name ? userProfile.personality.name : `${userProfile.personality.lastName ? userProfile.personality.lastName : ''} ${userProfile.personality.firstName ? userProfile.personality.firstName : ''} ${userProfile.personality.middleName ? userProfile.personality.middleName : ''}`;
                if (!userProfile.contacts) {
                    userProfile.contacts = {};
                }
                if (!userProfile.address) {
                    userProfile.address = {};
                }
                return userProfile;
            }
            return JSON.parse(linkStore.getUserInfo());
        }
        catch (ex) {
            return null;
        }
    }

    /**
     * Запишем информацию о пользователе
     */
    static setUserInfo(userInfo) {
        if (userInfo && Object.prototype.hasOwnProperty.call(userInfo, 'accessToken')) {
            userInfo.access_token = userInfo.accessToken;
            delete userInfo.accessToken;
        }
        let oldUserInfo = AuthService.getUserInfo();
        let newUserInfo = oldUserInfo ? userInfo ? Object.assign(oldUserInfo, userInfo) : null : userInfo;
        if (newUserInfo) {
            newUserInfo.personality = newUserInfo.personality && (newUserInfo.personality.lastName || newUserInfo.personality.firstName) ? newUserInfo.personality : {
                lastName: newUserInfo.personality && newUserInfo.personality.lastName ? newUserInfo.personality.lastName : 'Анонимный',
                firstName: newUserInfo.personality && newUserInfo.personality.firstName ? newUserInfo.personality.firstName : 'Пользователь',
            };
            linkStore.setUserInfo(JSON.stringify(newUserInfo));
        }
        else {
            linkStore.removeUserInfo();
        }
    }

    /**
     * Получаем информацию по пользователю
     * @returns {Array}
     */
    static getUserGroupInfo() {
        try {
            return JSON.parse(window.localStorage.getItem('TheVoiceAdminGroupInfo'));
        }
        catch (ex) {
            return null;
        }
    }

    /**
     * Запишем информацию о пользователе
     */
    static setUserGroupInfo(group) {
        window.localStorage.setItem('TheVoiceAdminGroupInfo', JSON.stringify(group));
    }

    /**
     * Получить роли пользователя
     * @returns {string[]}
     */
    static getUserRoles() {
        const userInfo = AuthService.getUserInfo();
        return userInfo && userInfo.currentUser && userInfo.currentUser.authorities
            ? userInfo.currentUser.authorities
            : [];
    }

    /**
     * Пользователь имеет данную роль
     * @param role
     * @returns {boolean}
     */
    static userHasRole(role) {
        const userRoles = this.getUserRoles();
        if (!userRoles) return false;
        return userRoles.includes(role);
    }

    /**
     * Получаем информацию по пользователю
     * @returns {String}
     */
    static getUserMessageStationsInfo() {
        try {
            return JSON.parse(window.localStorage.getItem('TheVoiceAdminMessageStationsInfo'));
        }
        catch (ex) {
            return null;
        }
    }

    /**
     * Запишем информацию о пользователе
     */
    static setUserMessageStationsInfo(messageStations) {
        window.localStorage.setItem('TheVoiceAdminMessageStationsInfo', JSON.stringify(messageStations));
    }

    /**
     * Выйти из учётки
     */
    static logOut() {
        window.location = window.location.href.split('#')[0] + '#/login';

        const afterLogoutCallback = () => {
            AuthService.setUserInfo(null);
            AuthService.setUserGroupInfo(null);
            AuthService.setUserMessageStationsInfo(null);
        };

        authActions.logOut()
            .finally(afterLogoutCallback);

    }

    /**
     * Проверяем пароль на длину
     * @param {*} password
     * @param {*} length
     */
    static checkSymbolsLength(password, length = AuthService.DEFAULT_MIN_PASSWORD_LENGTH) {
        if (!password) {
            return false;
        }
        return password.length >= length;
    }

    /**
     * Проверяем, что в пароле есть латинские буквы
     * @param {*} password
     */
    static checkLetters(password) {
        if (!password) {
            return false;
        }
        const regExp = /[a-zA-Z]{1}/;
        return regExp.test(password);
    }

    /**
     * Проверяем, что в пароле есть маленькие латинские буквы
     * @param {*} password
     */
    static checkLowerCase(password) {
        if (!password) {
            return false;
        }
        const regExp = /[a-z]{1}/;
        return regExp.test(password);
    }

    /**
     * Проверяем, что в пароле есть большие латинские буквы
     * @param {*} password
     */
    static checkUpperCase(password) {
        if (!password) {
            return false;
        }
        const regExp = /[A-Z]{1}/;
        return regExp.test(password);
    }

    /**
     * Проверяем, что в пароле есть цифры
     * @param {*} password
     */
    static checkNumbers(password) {
        if (!password) {
            return false;
        }
        const regExp = /[0-9]{1}/;
        return regExp.test(password);
    }
}
